import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/push/pushMessage/new',
    owner: '/home',
    // authority: 'discussionAdd',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/push/pushMessage/:id/mod',
    owner: '/home',
    // authority: 'discussionEdit',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/push/pushMessage/:id/check',
    owner: '/home',
    // authority: 'discussionEdit',
    component: Loadable({
      loader: () => import('./check'),
      loading: () => <RouteLoading />
    })
  },
];